<template>
  <div class="threejsContainer">
    <div class="containerTitle">1-1.fire<button @click="changeMe">报警开关</button><button @click="changeTwinklingStyle">闪烁方式改变</button></div>
    <div ref="container" class="containerBody"></div>
    
  </div>
</template>

<script>
/**
 * 备注：this.cube2.material.depthTest = false, 
 *      这是关键，设置为false后，关闭深夜测试，启用renderOrder，
 *      renderOrder越大，显示的渲染越靠后，显示越上层。
 * 
 * “图层切换”按钮负责切换深度测试
 */
import * as THREE from 'three';
import {generateScene} from '@/threejsEnv/scene.js';
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls.js';
import {genPerspectiveCamera} from '@/threejsEnv/camera.js';
import {genRenderer} from '@/threejsEnv/renderer.js';
import {MyCube} from '@/material/MyCube/index.js';

export default {
  data() {
    return {
      scene: null,
      camera: null,
      renderer: null,
      controls: null,
      currentMesh: null,
      cube1: null,
      cube2: null,
      u_time: 0,
      window: {
        width: 0,
        height: 0
      },
      animationId: null
    };
  },
  mounted() {
    //初始化环境
    this.initEnv();
    //创建网格对象
    this.createMesh();
    this.animate();
    // 监听窗口大小变化
    window.addEventListener('resize', this.onWindowResize);
  },
  methods: {
    changeMe(){
      if(this.cube2.isOpen()){
        this.cube2.close();
      }else{
        this.cube2.open();
      }
    },
    changeTwinklingStyle(){
      let twinkingStyle = this.cube2.getTwinklingStyle();
      this.cube2.setTwinklingStyle((twinkingStyle+1)%2);
    },
    createMesh() {
      const geometry1 = new THREE.BoxGeometry();
      const material1 = new THREE.MeshBasicMaterial({ color: 0x00ff00});
      this.cube1 = new THREE.Mesh(geometry1, material1);
      this.cube1.position.x = 0.5;
      this.cube1.renderOrder = 1; 
      this.scene.add(this.cube1);

      this.cube2 = new MyCube();
      this.cube2.scale.set(0.3, 0.3, 0.3);
      this.cube2.position.x = -0.2;
      this.cube2.setTwinklingStyle(1);
      this.scene.add(this.cube2);
    },
    animate() {
      this.animationId = requestAnimationFrame(this.animate);
      this.controls.update();
      this.renderer.render(this.scene, this.camera);
      this.cube2.twinkling();
    },
    initEnv(){
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      // 初始化场景
      this.scene = generateScene();
      this.scene.background = new THREE.Color(0xffffff);

      // 初始化相机
      this.camera = genPerspectiveCamera(this.window);

      // 初始化渲染器
      this.renderer = genRenderer(this.window);
      this.$refs.container.appendChild(this.renderer.domElement);

      // 添加轨道控制器
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      this.controls.enableDamping = true;

      // 创建光源
      const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
      this.scene.add(ambientLight);
      
      const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
      directionalLight.position.set(10, 20, 15);
      this.scene.add(directionalLight);

      const gridHelper = new THREE.GridHelper(100, 100,
                                              0x666666,   // 中心轴线颜色（红色）
                                              0xcccccc    // 普通网格线颜色（绿色）
                                              ); // 10x10 网格
      this.scene.add(gridHelper);
    },
    onWindowResize() {
      const width = this.$refs.container.clientWidth;
      const height = this.$refs.container.clientHeight;

      // 更新相机
      this.camera.aspect = width / height;
      this.camera.updateProjectionMatrix();

      // 更新渲染器
      this.renderer.setSize(width, height);
    }
  },
  beforeDestroy() {
    // 清理动画和事件监听
    cancelAnimationFrame(this.animationId);
    window.removeEventListener('resize', this.onWindowResize);
    
    // 释放资源
    if (this.currentMesh) {
      this.scene.remove(this.currentMesh);
      this.currentMesh.geometry.dispose();
      this.currentMesh.material.dispose();
    }
    
    this.controls.dispose();
    this.renderer.dispose();
    this.renderer.domElement.remove();
  }
};
</script>

<style>
</style>
